import UserNameItem from "../../Users/UsersRowItems/UserNameItem";
import { DateTime as DT } from "luxon";
import OperationWarehouse from "./OperationItems/OperationWarehouse";
import ProductOperPrice from "../ProductOperPrice";
import CountBadge from "../CounBadge";
import vconst from "utils/helpers/structs/vconst";
import EOverlay from "../../others/EOverlay";
import { useAuth } from "context/AuthContext";
import { escapeHtml } from "utils/helpers/functions/escapeHtml";
 

const OperationTableRow = ({operation}) => {
    const { auth } = useAuth();
    const dt = DT.fromMillis(operation?.dt || 0).toFormat('dd.MM.yyyy');

    const operDescriptionHtml = [
        operation?.operDescription ? `<div>${escapeHtml(String(operation.operDescription))}</div>` : '',
        operation?.operSetName
            ? `<div class="mt-1"><span class="badge bg-light-primary">Набір: ${escapeHtml(String(operation.operSetName))}</span></div>`
            : '',
    ]
        .filter(Boolean)
        .join('');

    return (
    <tr className={vconst?.bgRowOperStat?.[operation.operStatus]||''}>
        <td className="username"> 
            <UserNameItem
                user={{ 
                    userName: operation.userName,
                    userEmail: operation.userEmail,
                    userPicture: operation.userPicture,
                }}/>
        </td>
        <td className="set text-truncate">
            {operation?.operSetName ? (
                <span className="badge bg-light-primary">{operation.operSetName}</span>
            ) : (
                <span className="text-muted">-</span>
            )}
        </td>
        <td className="date text-truncate">
            <span className="d-block mb-1 cursor-pointer text-break">{dt}</span>
            <span className="d-block d-md-none text-muted fw-medium text-truncate">{operation.userName}</span>
        </td>
        <td className="count text-truncate">
            <CountBadge
                count={operation.operCount}/>
        </td>
        {auth?.user?.access?.role == 'manager' && 
            (<td className="price text-truncate">
                <ProductOperPrice
                    operation={operation}/>
            </td>)}
        <td className="warehouse text-truncate">
            <OperationWarehouse
                operation={operation}/> 
        </td>

        <td className="description">
                
            <EOverlay
                text={operDescriptionHtml}/>




        </td>
         
    </tr>)
}

export default OperationTableRow;